import React, { useState } from "react"
import { Link } from "gatsby"
import isExternalLink from "@/utils/is-external-link"
import { gtmTracking } from "@/utils/gtm-tracking"

/**
 *  SecondaryNav component
 * @param {string} navTitle - The title of the secondary nav
 * @param {string} navTitleLink - The URL the title should link to
 * @param {array} items - The array of items to display in the secondary nav
 * @param {string} items.title - The title of the item
 * @param {string} items.url - The url of the item
 * @returns
 */
const SecondaryNav = ({ navTitle, navTitleLink, items }) => {
  const [showNav, setShowNav] = useState(false)

  return (
    <>
      <div className="secondary-nav secondary-nav--mobile">
        <button
          className="mb-0 p secondary-nav__button"
          onClick={() => setShowNav(!showNav)}
        >
          {navTitle}
          <svg
            className={`secondary-nav__icon ${
              showNav ? "secondary-nav__icon--open" : ""
            }`}
            fill="currentColor"
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
          >
            <path d="M12 15.5l-6-6 1.41-1.41L12 12.67l4.59-4.58L18 9.5l-6 6z" />
          </svg>
        </button>

        {showNav && items.length > 0 && (
          <div className="secondary-nav__items">
            {items.map((item, index) =>
              isExternalLink(item.link) ? (
                <a
                  href={item.link}
                  key={index}
                  className="secondary-nav__item"
                  onClick={() =>
                    gtmTracking("Secondary Top Nav", item.name, "")()
                  }
                >
                  {item.name}
                </a>
              ) : (
                <Link
                  to={item.link}
                  key={index}
                  className="secondary-nav__item"
                  onClick={() => gtmTracking("Secondary Nav", item.name, "")()}
                >
                  {item.name}
                </Link>
              ),
            )}
          </div>
        )}
      </div>

      <div className="secondary-nav secondary-nav--desktop">
        {navTitle && navTitleLink ? (
          <Link
            to={navTitleLink}
            className="secondary-nav__title text-bold"
            onClick={() => gtmTracking("Secondary Nav", navTitle, "")()}
          >
            {navTitle}
          </Link>
        ) : (
          <span className="text-bold">{navTitle}</span>
        )}

        <div className="secondary-nav__divider"></div>

        <div className="secondary-nav__items">
          {items.map((item, index) =>
            isExternalLink(item.link) ? (
              <a
                href={item.link}
                key={index}
                className="secondary-nav__item"
                onClick={() =>
                  gtmTracking("Link Click", item.name, "Secondary Navigation")()
                }
              >
                {item.name}
              </a>
            ) : (
              <Link
                to={item.link}
                key={index}
                className="secondary-nav__item"
                onClick={() =>
                  gtmTracking("Link Click", item.name, "Secondary Navigation")()
                }
              >
                {item.name}
              </Link>
            ),
          )}
        </div>
      </div>
    </>
  )
}

export default SecondaryNav
